var Actions;
(function (Actions) {
    Actions["GET_ASSET_CATEGORY_LIST"] = "getAssetCategoryList";
    Actions["GET_ASSET_CATEGORY_LIST_CODE_DESC"] = "getAssetCategoryListCodeDesc";
    Actions["CREATE_ASSET_CATEGORY_LIST"] = "createAssetCategoryList";
    Actions["UPDATE_ASSET_CATEGORY_LIST"] = "updateAssetCategoryList";
    Actions["GET_ASSET_CATEGORY_LIST_FILTER"] = "getAssetCategoryListFilter";
    Actions["GET_ASSET_CATEGORY_DATA"] = "getAssetCategoryData";
    Actions["UPDATE_SELECTED_ASSET_CATEGORY_CODE"] = "updateSelectedAssetCategoryCode";
    Actions["UPDATE_SELECTED_ASSET_CATEGORY_DESC"] = "updateSelectedAssetCategoryDesc";
    Actions["UPDATE_SELECTED_ASSET_CATEGORY_ACTIVE"] = "updateSelectedAssetCategoryActive";
    Actions["UPDATE_ASSET_CATEGORY_SIZE"] = "updateAssetCategorySize";
    Actions["RESET_ASSET_CATEGORY_FILTER"] = "resetAssetCategoryFilter";
    Actions["DOWNLOAD_ASSET_CATEGORY"] = "downloadAssetCategory";
    Actions["UPDATE_ASSET_CATEGORY_PAGE_FILTER"] = "updateAssetCategoryPageFilter";
    Actions["UPDATE_SEARCH_ASSET_CATEGORY_DESC"] = "updateSearchAssetCategoryDesc";
    Actions["UPDATE_SEARCH_ASSET_CATEGORY_CODE"] = "updateSearchAssetCategoryCode";
})(Actions || (Actions = {}));
var Mutations;
(function (Mutations) {
    Mutations["SET_ASSET_CATEGORY_WAS_FIRST_LOAD"] = "setAssetCategoryWasFirstLoad";
    Mutations["SET_ASSET_CATEGORY_LOADING"] = "setAssetCategoryLoading";
    Mutations["SET_ASSET_CATEGORY_HANDLE_PAGE"] = "setAssetCategoryHandlePage";
    Mutations["SET_ASSET_CATEGORY_LIST"] = "setAssetCategoryList";
    Mutations["SET_ASSET_CATEGORY_LIST_CODE"] = "setAssetCategoryListCode";
    Mutations["SET_ASSET_CATEGORY_LIST_DESC"] = "setAssetCategoryListDesc";
    Mutations["SET_ASSET_CATEGORY_PAGE"] = "setAssetCategoryPage";
    Mutations["SET_ASSET_CATEGORY_LOAD_PAGE"] = "setAssetCategoryLoadPage";
    Mutations["SET_SELECTED_ASSET_CATEGORY_CODE"] = "setSelectedAssetCategoryCode";
    Mutations["SET_SELECTED_ASSET_CATEGORY_DESC"] = "setSelectedAssetCategoryDesc";
    Mutations["SET_SELECTED_ASSET_CATEGORY_ACTIVE"] = "setSelectedAssetCategoryActive";
    Mutations["SET_ASSET_CATEGORY_STATUS"] = "setAssetCategoryStatus";
    Mutations["SET_ASSET_CATEGORY_SIZE"] = "setAssetCategorySize";
    Mutations["SET_ASSET_CATEGORY_USE_FILTER"] = "setAssetCategoryUseFilter";
    Mutations["SET_ASSET_CATEGORY_PAGE_FILTER"] = "setAssetCategoryPageFilter";
    Mutations["SET_ASSET_CATEGORY_WAS_LOAD_QUICK_FILTER"] = "setAssetCategoryWasLoadQuickFilter";
    Mutations["SET_ASSET_CATEGORY_SEARCH_BY"] = "setAssetCategorySearchBy";
    Mutations["SET_ASSET_CATEGORY_SEARCH_KEY"] = "setAssetCategorySearchKey";
})(Mutations || (Mutations = {}));
export { Actions, Mutations };
